import type { MusicOnHoldLocale } from './en'

export const musicOnHoldKo = {
  list: {
    title: `대기 음악`,
    loading: `재생 목록 로딩 중...`,
    error: `오류`,
    empty: `재생 목록을 찾을 수 없습니다`,
    emptyDescription: `이 PBX에 대해 현재 구성된 재생 목록이 없습니다.`,
    noResults: `결과 없음`,
    noResultsDescription: `검색과 일치하는 재생 목록이 없습니다.`,
    columnName: `이름`,
    columnType: `유형`,
    columnTracks: `트랙`,
    columnUpdated: `업데이트됨`,
    columnDefault: `기본`,
    columnPlayer: `미리보기`,
    noPreview: `오디오 없음`,
    previewInDetail: `트랙 미리 듣기를 열기`,
    defaultDisabledTooltip: `기본으로 설정하려면 재생 목록에 오디오 트랙이 하나 이상 있거나 스트림 URL이 있어야 합니다.`,
    defaultCurrentTooltip: `현재 기본 재생 목록입니다.`,
    defaultSetTooltip: `기본 재생 목록으로 설정`,
    defaultBadge: `기본`,
    systemBadge: `시스템`,
    notPlayableBadge: `재생 불가`,
    typeList: `목록`,
    tracksLabel: `트랙`,
    streaming: `스트리밍`,
    myPlaylists: `내 재생 목록`,
    systemPlaylists: `시스템 재생 목록`,
    searchPlaceholder: `재생 목록 검색...`,
    manageTracksButton: `오디오 트랙`,
    createButton: `+ 재생 목록 만들기`,
    createDisabledTooltip: `재생 목록 만들기는 아직 사용할 수 없습니다.`,
    columnActions: `작업`,
    deleteAriaLabelNamed: `재생 목록 "{{name}}" 삭제`,
    deleteConfirmTitle: `재생 목록을 삭제하시겠습니까?`,
    deleteConfirmBody: `"{{name}}"을(를) 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.`,
    deleteConfirm: `삭제`,
    deleteCancel: `취소`,
    deleteDefaultWarning: `기본 대기 음악 재생 목록입니다. 삭제하면 시스템 기본값으로 대체됩니다.`,
  },
  detail: {
    loading: `재생 목록 로딩 중...`,
    error: `오류`,
    notFound: `재생 목록을 찾을 수 없습니다.`,
    backToList: `← 목록으로 돌아가기`,
    editButton: `재생 목록 편집`,
    editDisabledTooltip: `편집은 아직 사용할 수 없습니다`,
    defaultBadge: `기본`,
    systemBadge: `시스템`,
    generalTitle: `일반 정보`,
    nameLabel: `이름`,
    typeLabel: `유형`,
    typeList: `목록`,
    defaultLabel: `기본`,
    defaultYes: `예`,
    defaultNo: `아니오`,
    activeLabel: `활성`,
    activeYes: `예`,
    activeNo: `아니오`,
    idLabel: `ID`,
    uuidLabel: `UUID`,
    createdLabel: `생성됨`,
    updatedLabel: `업데이트됨`,
    audioTracksTitle: `오디오 트랙`,
    noAudioTracks: `이 재생 목록과 연결된 오디오 트랙이 없습니다.`,
    manageTracksButton: `트랙 관리`,
  },
  audioTracks: {
    title: `오디오 트랙`,
    loading: `오디오 트랙 로딩 중...`,
    empty: `이 PBX에 업로드된 오디오 트랙이 없습니다.`,
    columnName: `이름`,
    columnFile: `파일`,
    uploadButton: `음악 업로드`,
    close: `닫기`,
    nameLabel: `트랙 이름`,
    namePlaceholder: `트랙 이름을 입력하세요`,
    nameRequired: `트랙 이름을 입력해 주세요.`,
    audioFileRequired: `오디오 파일을 선택해 주세요.`,
    fileTypeInvalid: `WAV 또는 MP3 파일만 지원됩니다.`,
    fileSizeExceeded: `파일이 25 MB 제한을 초과했습니다 ({{size}} MB).`,
    dropzonePlaceholder: `WAV 또는 MP3 파일을 끌어다 놓거나 클릭하여 선택하세요`,
    dropzoneAccepted: `WAV, MP3 (최대 25 MB)`,
    removeFile: `제거`,
    cancel: `취소`,
    uploadSubmit: `업로드`,
    uploading: `업로드 중...`,
    uploadFailed: `업로드 실패`,
    deleteConfirmTitle: `오디오 트랙을 삭제하시겠습니까?`,
    deleteConfirmBody: `"{{name}}"을(를) 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.`,
    deleteConfirm: `삭제`,
    deleteFailed: `삭제 실패`,
    deleteAriaLabel: `오디오 트랙 삭제`,
  },
  createModal: {
    title: `새 재생 목록`,
    nameLabel: `이름`,
    namePlaceholder: `재생 목록 이름 입력`,
    cancel: `닫기`,
    submit: `재생 목록 만들기`,
  },
  editModal: {
    title: `재생 목록 편집`,
    nameLabel: `이름`,
    namePlaceholder: `재생 목록 이름 입력`,
    cancel: `취소`,
    submit: `변경 사항 저장`,
    error: `재생 목록 저장 실패`,
  },
  manageTracks: {
    title: `트랙 관리`,
    inPlaylistTitle: `이 재생 목록에 포함됨`,
    availableTitle: `사용 가능한 트랙`,
    noneAssigned: `아직 이 재생 목록에 추가된 트랙이 없습니다.`,
    noTracksUploaded: `이 PBX에 업로드된 오디오 트랙이 없습니다.`,
    allAdded: `사용 가능한 모든 트랙이 이미 이 재생 목록에 있습니다.`,
    add: `추가`,
    remove: `제거`,
    done: `완료`,
    addFailed: `트랙 추가 실패`,
    removeFailed: `트랙 제거 실패`,
  },
  trackPlay: {
    play: `재생`,
    loading: `불러오는 중…`,
    error: `미리 듣기를 사용할 수 없음`,
    close: `미리 듣기 닫기`,
  },
  pagination: {
    resultsPerPage: `페이지당 결과:`,
    previousPage: `이전 페이지`,
    nextPage: `다음 페이지`,
    jumpToPage: `{{page}}페이지로 이동`,
    all: `전체`,
  },
} satisfies MusicOnHoldLocale
